import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCompassPointer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCompassPointer"><Path d="M4 20L12 3.25L20 20L12 17L4 20Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconCompassPointer;
